module.exports = __webpack_public_path__ + "img/img6.372d39f3.svg";